import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { localizations } from '../../localization/localization';

type SubmitType = () => void;
type CancelType = () => void;

interface DeleteContactConfirmProps {
    contact: string;    
}

type Props = DialogPropsBase<SubmitType, CancelType> & DeleteContactConfirmProps;

const DeleteEmailConfirmation: React.SFC<Props> = (props) => {
    return <Dialog open={props.isOpen}>
        <DialogTitle>{localizations.settings.deleteEmailConfirmationTitle}</DialogTitle>
        <DialogContent>
            <Typography paragraph>
                {localizations.settings.deleteEmailConfirmationQuestion} <strong>{`${props.contact}`}</strong>?
            </Typography>            
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onCancel()}>{localizations.actions.cancel}</Button>
            <Button onClick={() => props.onSubmit()}>{localizations.actions.accept}</Button>
        </DialogActions>
    </Dialog>
}

export default DeleteEmailConfirmation;


// WEBPACK FOOTER //
// ./src/account/forms/DeleteEmailConfirmation.tsx